import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import style from './Navbar.module.css';
import { Link } from 'react-router-dom';
import { logout_Api, current_user_Api } from '../../dashboardapi';
import Modal from "../Dashboardcomponents/Modal"
import { useToast } from '@chakra-ui/react';
import { HashLink } from 'react-router-hash-link';
import templatestyle from "../Dashboardcomponents/TemplateModal.module.css"
import { useRef } from 'react';
const Navbar = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [activeLink, setActiveLink] = useState("#hero");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [loggedIn, setLoggedIn] = useState(false);
    const [signedin, setSignedIn] = useState(false);
    const location = useLocation();
    const [ToogleAccountInfo, setToogleAccountInfo] = useState(false)
    const [userDetails, setUserDetails] = useState({})
    const [showSignoutModal, setShowSignOutModal] = useState(false);
    const [reRender, setReRender] = useState(false);
    const [toogleMobileAccount, setToogleMobileAccount] = useState(false);
    const [toogleShowSignout, setToogleShowSignout] = useState(false);
    const toast = useToast();
    const signoutModalRef = useRef(null);
    const closeSignoutModalRef = useRef(null);
    const Templatenavigate = useNavigate();
    useEffect(() => {
        if (location.pathname === "/home") {
            setActiveLink("#hero"); // default section in home
        } else if (location.pathname === "/templates") {
            setActiveLink("/templates"); // default in template page
        } else {
            setActiveLink("")
        }
    }, [location.pathname]);
    useEffect(() => {
        // const token = localStorage.getItem("token");
        // const isUserLoggedIn = !!token;
        // setLoggedIn(isUserLoggedIn);
        console.log(location.pathname);
        // alert("logged in status " + (isUserLoggedIn ? "true" : "false"));
        signverification();
    }, []);
    useEffect(() => {
        if (!toogleShowSignout) return; // only add listener when modal is open

        const handleClickOutside = (e) => {
            if (signoutModalRef.current && !signoutModalRef.current.contains(e.target)) {
                setToogleShowSignout(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [toogleShowSignout]);

    useEffect(() => {
        if (!ToogleAccountInfo) return; // only add listener when modal is open

        const handleClickOutsideAccountInfo = (e) => {
            if (closeSignoutModalRef.current && !closeSignoutModalRef.current.contains(e.target)) {
                setToogleAccountInfo(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutsideAccountInfo);

        return () => document.removeEventListener('mousedown', handleClickOutsideAccountInfo);
    }, [ToogleAccountInfo]);

    useEffect(() => {
        if (location.pathname !== "/home") return;

        const sectionIds = ["hero", "about", "features", "pricing", "faqs"];

        const handleScroll = () => {
            let current = "";
            sectionIds.forEach((id) => {
                const section = document.getElementById(id);
                if (section) {
                    const top = section.getBoundingClientRect().top;

                    if (top <= 120 && top > -section.offsetHeight + 120) {
                        current = `#${id}`;
                    }
                }
            });

            if (current && current !== activeLink) {
                setActiveLink(current);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [location.pathname, activeLink]);


    useEffect(() => {
        let details = async () => {
            try {
                let result = await current_user_Api();
                if (result.data) {
                    setUserDetails(result.data.message)
                }
            } catch (error) {
                console.log(error);
            }
        }
        if (localStorage.getItem("token")) {
            details();
        }
    }, [])

    const signverification = () => {
        const signedinDetails = localStorage.getItem("token");
        if (signedinDetails) {
            setSignedIn(true);
        }
    }

    // Handle window resize to detect mobile/desktop
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
                setMobileMenuOpen(false); // Close mobile menu if switching to desktop
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const TemplatehandleSignOut = async (e) => {
        let response = await logout_Api();
        console.log(response)

        if (response.data) {
            localStorage.removeItem("token");
            setSignedIn(false);
            setShowSignOutModal(false);
            setToogleAccountInfo(false);
            setToogleShowSignout(false)
            toast({
                title: "Signed Out Successfully",
                description: "",
                status: "success",
                duration: 2000,
                isClosable: "true"
            })

        } else {
            toast({
                title: "Problem signing out",
                description: "Please try again later",
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }



    return (

        <div>
            <div className='container'>
                <div className={style.navbar}>
                    <div className={style.logo}>
                        <img src={process.env.PUBLIC_URL + "/NewPages/Homepage/LogoMobile.svg"} alt="Logo" />
                    </div>

                    {/* Desktop menu */}
                    {!isMobile && (
                        <>
                            <div className={style.navbar_elements_container}>
                                <ul className={style.navbar_elements}>
                                    {location.pathname !== "/templates" && (
                                        <>
                                            <li>
                                                <HashLink
                                                    smooth
                                                    to="/home#hero"
                                                    className={activeLink === "#hero" ? style.navActiveLink : ""}
                                                    onClick={() => setActiveLink("#hero")}
                                                >
                                                    Home
                                                </HashLink>
                                            </li>
                                            <li>
                                                <HashLink
                                                    smooth
                                                    to="/home#about"
                                                    className={activeLink === "#about" ? style.navActiveLink : ""}
                                                    onClick={() => setActiveLink("#about")}
                                                >
                                                    About
                                                </HashLink>
                                            </li>
                                        </>
                                    )}

                                    <li>
                                        <HashLink
                                            smooth
                                            to="/home#features"
                                            className={activeLink === "#features" ? style.navActiveLink : ""}
                                            onClick={() => setActiveLink("#features")}
                                        >
                                            Features
                                        </HashLink>
                                    </li>
                                    <li>
                                        <Link
                                            className={activeLink === "/templates" ? style.navActiveLink : ""}
                                            onClick={() => setActiveLink("/templates")}
                                            to="/templates"
                                        >
                                            Template
                                        </Link>
                                    </li>
                                    <li>
                                        <HashLink
                                            smooth
                                            to="/home#pricing"
                                            className={activeLink === "#pricing" ? style.navActiveLink : ""}
                                            onClick={() => setActiveLink("#pricing")}
                                        >
                                            Pricing
                                        </HashLink>
                                    </li>
                                    <li>
                                        <HashLink
                                            smooth
                                            to="/home#faqs"
                                            className={activeLink === "#faqs" ? style.navActiveLink : ""}
                                            onClick={() => setActiveLink("#faqs")}
                                        >
                                            FAQs
                                        </HashLink>
                                    </li>
                                </ul>
                            </div>
                        </>
                    )}
                    {(!isMobile && !signedin) && (
                        <>
                            <div className={loggedIn ? style.loggedIn_style : style.navbar_login_container}>
                                <button className={style.navbar_signin}>
                                    <Link to="/signin" style={{ color: "#f44f0d", "font-weight": "bold" }}>Sign in</Link>
                                </button>
                                <button className={style.navbar_signup}>
                                    <Link to="/signup" style={{ "font-weight": "bold" }}>Sign up</Link>
                                </button>
                            </div>
                        </>)}
                    {(!isMobile && signedin) &&
                        (
                            <>
                                <div style={{ display: "flex", gap: "10px", position: "relative" }}>
                                    {/* <ul className={style.navbar_elements}>
                                    <li><Link to={"/dashboard/myprojects"}>Projects</Link></li>
                                </ul> */}
                                    {(!isMobile && signedin) &&
                                        (<ul style={{ listStyle: "none", marginRight: "10px" }}>
                                            <li style={{ color: "#15141c" }}><Link to={"/dashboard/myprojects"}>Projects</Link></li>
                                        </ul>
                                        )}
                                    <button onClick={() => setToogleAccountInfo(!ToogleAccountInfo)} className={style.NavbarDownarrow}>Account  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 6L8 10L12 6" stroke="#15141C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    </button>
                                    {
                                        ToogleAccountInfo && (
                                            <div ref={closeSignoutModalRef} className={style.NavbarAccountInfo}>
                                                <p style={{ color: "black" }}>{userDetails}</p>
                                                <button style={{ color: "red" }} onClick={() => {
                                                    setToogleShowSignout(true); setToogleAccountInfo(false);
                                                }}>Sign Out</button>
                                            </div>
                                        )
                                    }
                                </div>
                            </>
                        )}

                    {/* Mobile hamburger menu */}
                    {isMobile && (
                        <div
                            className={style.mobile_menu_icon}
                            onClick={() => setMobileMenuOpen(prev => !prev)}
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1806_2609)">
                                    <path d="M9.99805 6H19.998" stroke="#15141C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M3.99805 12H19.998" stroke="#15141C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M6.99805 12H19.998" stroke="#15141C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9.99805 18H19.998" stroke="#15141C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1806_2609">
                                        <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>

                        </div>
                    )}

                    {/* Mobile menu links */}
                    {mobileMenuOpen && isMobile && (
                        <div className={style.mobile_menu_links}>
                            <ul>
                                {/* <li><a href="#hero">Home</a></li>
                                <li><a href="#about">About</a></li>
                                <li><a href="#features">Features</a></li>
                                <li><Link to={"/templates"}>Template</Link></li>
                                <li><a href="#pricing">Pricing</a></li>
                                <li><a href="#faqs">FAQs</a></li> */}
                                <li>
                                    <HashLink
                                        smooth
                                        to="/home#hero"
                                        className={activeLink === "#hero" ? style.navActiveLink : ""}
                                        onClick={() => { setActiveLink("#hero"); setMobileMenuOpen(false) }}
                                    >
                                        Home
                                    </HashLink>
                                </li>
                                <li>
                                    <HashLink
                                        smooth
                                        to="/home#about"
                                        className={activeLink === "#about" ? style.navActiveLink : ""}
                                        onClick={() => { setActiveLink("#about"); setMobileMenuOpen(false) }}
                                    >
                                        About
                                    </HashLink>
                                </li>



                                <li>
                                    <HashLink
                                        smooth
                                        to="/home#features"
                                        className={activeLink === "#features" ? style.navActiveLink : ""}
                                        onClick={() => { setActiveLink("#features"); setMobileMenuOpen(false) }}
                                    >
                                        Features
                                    </HashLink>
                                </li>
                                <li>
                                    <Link
                                        className={activeLink === "/templates" ? style.navActiveLink : ""}
                                        onClick={() => { setActiveLink("/templates") }}
                                        to="/templates"
                                    >
                                        Template
                                    </Link>
                                </li>
                                <li>
                                    <HashLink
                                        smooth
                                        to="/home#pricing"
                                        className={activeLink === "#pricing" ? style.navActiveLink : ""}
                                        onClick={() => { setActiveLink("#pricing"); setMobileMenuOpen(false) }}
                                    >
                                        Pricing
                                    </HashLink>
                                </li>
                                <li>
                                    <HashLink
                                        smooth
                                        to="/home#faqs"
                                        className={activeLink === "#faqs" ? style.navActiveLink : ""}
                                        onClick={() => { setActiveLink("#faqs"); setMobileMenuOpen(false) }}
                                    >
                                        FAQs
                                    </HashLink>
                                </li>
                                {
                                    !signedin && (
                                        <>
                                            <li>
                                                <button className={style.navbar_signin}>
                                                    <Link to="/signin" style={{ color: "#f44f0d", "font-weight": "bold" }}>Sign in</Link>
                                                </button>
                                            </li>
                                            <li>
                                                <button className={style.navbar_signup}>
                                                    <Link to="/signup" style={{ "font-weight": "bold" }}>Sign up</Link>
                                                </button>
                                            </li>
                                        </>
                                    )
                                }
                                {
                                    signedin && (
                                        <>
                                            <li><Link to="/dashboard/myprojects">Projects</Link></li>
                                            <li style={{ display: 'flex', justifyContent: 'center' }}>

                                                <button onClick={() => { setToogleMobileAccount(p => !p) }} className={style.NavbarDownarrow}>Account
                                                </button>
                                            </li>
                                            {
                                                toogleMobileAccount && (
                                                    <>
                                                        <li style={{ display: 'flex', justifyContent: 'center' }}>{userDetails}</li>
                                                        <li style={{ display: 'flex', justifyContent: 'center' }}><button onClick={() => { setToogleShowSignout(true); setMobileMenuOpen(false); }}>Signout</button></li>

                                                    </>
                                                )
                                            }
                                        </>
                                    )
                                }





                            </ul>

                        </div>
                    )}
                </div>
            </div >
            <Modal show={toogleShowSignout}>
                <div ref={signoutModalRef} style={{ background: "white", borderRadius: "12px" }} className={templatestyle.warningcontainer}>

                    <div className={templatestyle.TemplateHeaderContainer}>
                        <p style={{ color: "black" }} >Sign Out</p>
                        <button onClick={() => setToogleShowSignout(false)}>

                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>

                    </div>

                    <div className={templatestyle.warningContent}>
                        <p style={{ color: "black" }}>Are your sure. You want to signout?</p>
                    </div>
                    <div className={templatestyle.warningbuttonsection}>
                        <button className={templatestyle.cancelBtn} onClick={() => { setToogleShowSignout(false); }} >Cancel</button>
                        <button className={templatestyle.DeleteWarningbtn} onClick={() => { TemplatehandleSignOut() }}>Signout</button>
                    </div>
                </div>
            </Modal>
        </div >
    );
};

export default Navbar;
